import React from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Layout } from '../../../widgets/Layout';
import { commonStyles, theme } from '../../../shared/lib/styles';
import { getQuizById } from '../data/quizzes';
import QuizEngine from '../../../features/quizzes/ui/QuizEngine';

const QuizPlayPage = () => {
    const { quizId } = useParams();
    const navigate = useNavigate();
    const quiz = getQuizById(quizId);

    if (!quiz) {
        return (
            <Layout>
                <div style={styles.container}>
                    <p>Викторина не найдена.</p>
                    <Link to="/quizzes" style={styles.backLink}>
                        ← К списку викторин
                    </Link>
                </div>
            </Layout>
        );
    }

    return (
        <Layout>
            <div style={styles.container}>
                <Link to="/quizzes" style={styles.backLink}>
                    ← К списку викторин
                </Link>
                <h1 style={styles.title}>
                    {quiz.emoji} {quiz.title}
                </h1>
                <QuizEngine quiz={quiz} onExit={() => navigate('/quizzes')} />
            </div>
        </Layout>
    );
};

const styles = {
    container: commonStyles.container,
    title: {
        ...commonStyles.title,
        marginBottom: theme.spacing.xl,
    },
    backLink: {
        display: 'inline-block',
        marginBottom: theme.spacing.lg,
        color: theme.colors.primary,
        textDecoration: 'none',
        fontSize: theme.fontSize.sm,
    },
};

export default QuizPlayPage;
